module.exports = __webpack_public_path__ + "static/img/footer-ico-gicp.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer-ico-gicp.png
// module id = juLs
// module chunks = 0